<template>
  <div
    tabindex="0"
    class="relative h-[52px] w-36 xl:w-48 pl-5 pr-2 flex items-center justify-between text-base font-sans border-solid border-gray-300 border rounded-3xl focus-within:border-black outline-2 cursor-pointer"
    @click="
      () => {
        isOpen = !isOpen
      }
    "
    @focusout="
      (event) => {
        if (event.relatedTarget){
          const relatedTarget = event.relatedTarget as HTMLBaseElement
          const target = event.target as HTMLBaseElement
          if (relatedTarget.contains(target) === false && target.contains(relatedTarget) === false ){
            isOpen = false
          }
        } else if (event.relatedTarget === null) {
          isOpen = false
        }
      }"
  >
    {{ filterTypeLabel }}
    <div class="flex gap-2">
      <div
        v-if="activeFilters.length > 0"
        class="ml-2 h-6 mt-1 leading-6 rounded-3xl text-blue text-center min-w-[24px] bg-[#2c2ca40a]"
      >
        {{ activeFilters.length }}
      </div>
      <DropdownIcon
        class="text-blue w-6 h-6 mt-2 transition-all duration-200 fill-current hover:text-blue outline-0"
      />
    </div>
    <div
      v-if="isOpen"
      class="flex flex-col absolute font-sans top-16 p-5 gap-4 bg-white min-w-full border border-gray-300 rounded-xl text-lg z-10 shadow-md"
      @click.stop=""
    >
      <FormCheckbox
        v-for="option in filterOptions"
        class="hover:text-black whitespace-nowrap"
        :class="[
          activeFilters.indexOf(option) !== -1 ? 'text-black' : 'text-gray-600',
        ]"
        :checked="activeFilters.indexOf(option) !== -1"
        @update:checked="setFilter(option)"
      >
        {{ option }}
      </FormCheckbox>
    </div>
  </div>
</template>

<script setup lang="ts">
import DropdownIcon from '~/assets/icons/dropdown.svg?component'

const props = withDefaults(
  defineProps<{
    modelValue: string[]
    filterTypeLabel: string
    filterOptions: string[]
  }>(),
  {
    modelValue: () => [],
  }
)

const emit = defineEmits<{
  (e: 'update:modelValue', value: string[]): void
}>()

const isOpen = ref(false)

const activeFilters = computed<string[]>({
  get: () => {
    return props.modelValue
  },
  set: (newValue) => emit('update:modelValue', newValue),
})

const setFilter = (filterLabel: string) => {
  const newFilters = [...activeFilters.value]
  if (newFilters.indexOf(filterLabel) !== -1) {
    newFilters.splice(newFilters.indexOf(filterLabel), 1)
    activeFilters.value = newFilters
    return
  }

  newFilters.push(filterLabel)
  activeFilters.value = newFilters
}
</script>
